var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForecastImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 -0.000366211H1C0.723858 -0.000366211 0.5 0.223491 0.5 0.499634V12.4996C0.5 12.7758 0.723858 12.9996 1 12.9996H2C2.27614 12.9996 2.5 12.7758 2.5 12.4996V0.499634C2.5 0.223491 2.27614 -0.000366211 2 -0.000366211Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.49963H4C3.72386 3.49963 3.5 3.72349 3.5 3.99963V12.4996C3.5 12.7758 3.72386 12.9996 4 12.9996H5C5.27614 12.9996 5.5 12.7758 5.5 12.4996V3.99963C5.5 3.72349 5.27614 3.49963 5 3.49963Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.99963H7C6.72386 6.99963 6.5 7.22349 6.5 7.49963V12.4996C6.5 12.7758 6.72386 12.9996 7 12.9996H8C8.27614 12.9996 8.5 12.7758 8.5 12.4996V7.49963C8.5 7.22349 8.27614 6.99963 8 6.99963Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.49963H10C9.72386 3.49963 9.5 3.72349 9.5 3.99963V12.4996C9.5 12.7758 9.72386 12.9996 10 12.9996H11C11.2761 12.9996 11.5 12.7758 11.5 12.4996V3.99963C11.5 3.72349 11.2761 3.49963 11 3.49963Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.99963H13C12.7239 6.99963 12.5 7.22349 12.5 7.49963V12.4996C12.5 12.7758 12.7239 12.9996 13 12.9996H14C14.2761 12.9996 14.5 12.7758 14.5 12.4996V7.49963C14.5 7.22349 14.2761 6.99963 14 6.99963Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastImage);
export default __webpack_public_path__ + "static/media/forecastImage.3d825e800e8c4da6147b5def1d18f067.svg";
export { ForwardRef as ReactComponent };